import env from 'config/env'

export const isDemoMode = env.MODE === 'demo'
